"use client";
import styles from "./HowToUseSideDrawer.module.scss";
import { cleanHtml } from "../../../utils/string/cleanHtml";
import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import { useState } from "react";
import { ListItem } from "@/components/__shared__/ListItem/ListItem.tsx";
import ArrowRight from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ArrowRight24PxOutlined";
type Props = {
  howtoUseContent: string | null | undefined;
};

export const HowToUseSideDrawerUI = ({ howtoUseContent }: Props) => {
  const [open, setOpen] = useState(false);
  if (!howtoUseContent) return null;

  return (
    <>
      <ListItem
        label="How to use"
        onClick={() => {
          setOpen(true);
        }}
        trailingIcon={<ArrowRight />}
        data-testid="drawer:howtouse"
      />
      <Drawer
        isOpen={open}
        onClose={() => {
          setOpen(false);
        }}
        heading={"How to use"}
        primaryButtonText="Close"
      >
        <div
          data-testid="howToUse:Description"
          className={styles.productDescriptionBody}
          dangerouslySetInnerHTML={{ __html: cleanHtml(howtoUseContent) || "" }}
        />
      </Drawer>
    </>
  );
};
